import { Component, Input, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RadioOptionInterface } from './radio-option.interface';

@Component({
  selector: 'app-radio-field',
  templateUrl: './radio-field.component.html',
  styleUrls: ['./radio-field.component.css']
})
export class RadioFieldComponent {
  @Input() id: string;
  @Input() controlName: string;
  @Input() key: string;
  @Input() form: FormGroup;
  @Input() options: RadioOptionInterface[];
  @Input() hideLabel = false;
  @Input() hideErrors = false;
  @ViewChild('error') error;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/components/forms/radio-field/radio-field.component.ts